var map = {
	"./KioskCards": [
		2714,
		714
	],
	"./KioskCards.tsx": [
		2714,
		714
	],
	"./Payments": [
		3835,
		835
	],
	"./Payments.tsx": [
		3835,
		835
	],
	"./Transactions": [
		5715,
		715
	],
	"./Transactions.tsx": [
		5715,
		715
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 481;
module.exports = webpackAsyncContext;